import { FC } from 'react'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ParcelBuildingLotAndLocationContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/property-records/building-and-lot/content'

export const ParcelBuildingLotAndLocationWidget: FC = () => {
  return (
    <WidgetCard
      id="building-lot-and-location"
      title="Building, Lot, and Location"
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      sections={[
        {
          content: <ParcelBuildingLotAndLocationContent />,
        },
      ]}
    />
  )
}
